import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
var _excluded = ["avatar", "badge", "size"];
import PropTypes from 'prop-types';
import React, { cloneElement } from 'react';
import { StyledBadgedAvatar } from './BadgedAvatar.styles';

/**
 * Composes an `Avatar` with `AvatarBadge`.
 *
 * @since 7.18.0
 */
export var BadgedAvatar = function BadgedAvatar(_ref) {
  var avatar = _ref.avatar,
    badge = _ref.badge,
    size = _ref.size,
    rest = _objectWithoutProperties(_ref, _excluded);
  var avatarClone = /*#__PURE__*/cloneElement(avatar, {
    size: size
  });
  var badgeClone = /*#__PURE__*/cloneElement(badge, {
    size: size
  });
  return /*#__PURE__*/React.createElement(StyledBadgedAvatar, rest, avatarClone, badgeClone);
};
BadgedAvatar.displayName = 'BadgedAvatar';
BadgedAvatar.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The `Avatar` component.
   */
  avatar: PropTypes.node.isRequired,
  /**
   * The `AvatarBadge` component.
   */
  badge: PropTypes.node.isRequired,
  /**
   * The avatar size. Note that only larger sizes are supported.
   */
  size: PropTypes.oneOf(['xxl', 'xl', 'lg'])
} : {};
BadgedAvatar.defaultProps = {
  size: 'lg'
};